import { createRoot } from 'react-dom/client';
import { Initializer } from 'Shared/chakra-initialize';
import { TiptapEditor } from './tiptap/tiptap';

const tiptapEditor = releaseNotes => {
   const EditorComponent = Initializer(TiptapEditor);
   const editorid = 'releaseNotes';
   const root = createRoot(releaseNotes);
   root.render(
      <EditorComponent
         editorid={editorid}
         // Release versions uses the GuideComment wiki renderer
         // (see ReleaseLiveObject::getRenderedNotes())
         preset="comments"
      />
   );
   return editorid;
};

export async function releaseVersionEditor(_keymapping) {
   const releaseNotes = document.getElementById('releaseNotes');

   if (!releaseNotes) {
      return;
   }

   return tiptapEditor(releaseNotes);
}
